import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import type { RefundCode } from 'Services/ControlDataManagement/Features/RefundCode/types'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import { Paper, styled, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface RefundCodeDetailsProps {
  refundCode: RefundCode
}

export default function RefundCodeDetails({ refundCode }: Readonly<RefundCodeDetailsProps>) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Identifier`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(refundCode.id)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Refund code identifier`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(refundCode.refund_code_id)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Explanation`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(refundCode.explanation)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(refundCode.created_timestamp)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Last modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(new Date(refundCode.modified_timestamp))}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
